/**
 * A tool's result fields as the dot paths a later step can take: every property, and for a list
 * its first row (`orders.0.id`).
 */

import { STEP_PATH } from './custom-tool-draft';

const MAX_DEPTH = 5;

const asRecord = (value: unknown): Record<string, unknown> | null =>
	typeof value === 'object' && value !== null && !Array.isArray(value) ? (value as Record<string, unknown>) : null;

const isList = (node: Record<string, unknown>): boolean =>
	node['type'] === 'array' || (Array.isArray(node['type']) && node['type'].includes('array'));

const pathsUnder = (schema: unknown, prefix: string, depth: number): string[] => {
	const node = asRecord(schema);
	if (!node || depth >= MAX_DEPTH) return [];
	const properties = asRecord(node['properties']);
	if (properties) {
		return Object.entries(properties).flatMap(([name, child]) => {
			const path = prefix ? `${prefix}.${name}` : name;
			return [path, ...pathsUnder(child, path, depth + 1)];
		});
	}
	if (prefix && isList(node)) {
		const row = `${prefix}.0`;
		return [row, ...pathsUnder(node['items'], row, depth + 1)];
	}
	return [];
};

export const outputPaths = (schema: unknown): string[] => pathsUnder(schema, '', 0).filter((path) => STEP_PATH.test(path));
